<template>
  <v-autocomplete
    no-data-text="Danh sách trống"
    v-bind="this.$attrs"
    item-text="display"
    :items="studentList"
    return-object
    @change="onChange"
    :search-input.sync="inputValue"
    clearable
    outlined
    dense
    label="Học sinh"
    :loading="loading"
    v-model="student"
  >
    <template v-slot:item="data">
      <v-list-item-content>
        <CardStudentInfo :student="data.item" />
      </v-list-item-content>
    </template>
  </v-autocomplete>
</template>

<script>
import api, { Class } from '../../../plugins/api'
import { debounce, get, orderBy } from 'lodash'
import utils from '@/plugins/utils.js'
import { Student } from '@/plugins/api'
import CardStudentInfo from '@/components/basic/card/CardStudentInfo.vue'
import { textHelpers } from '@/helpers/TextHelper'
import { mapGetters } from 'vuex'

export default {
  components: {
    CardStudentInfo
  },
  data: () => ({
    students: [],
    inputValue: '',
    loading: false,
    student: ''
  }),
  props: {
    filter: Object,
    options: Object,
    defaultStudent: Object,
    syncedValue: Object
  },
  watch: {
    async inputValue(search) {
      this.debounce(search, this)
    },
    filter(filter) {
      this.inputValue = null
      this.fetchStudents(filter)
    },
    syncedValue(value) {
      this.student = value
    }
  },
  methods: {
    async fetchStudents() {
      this.loading = true
      const params = {
        _sort: 'nameToNumber:ASC'
      }
      if (this.ownClassIds && !get(this.filter, 'currentClass')) {
        params['currentClass_in'] = this.ownClassIds
        this.students = await Student.fetch(params)
      } else {
        if (get(this.filter, 'currentClass')) {
          const classData = await Class.fetchOne(this.filter.currentClass)
          this.students = classData.students.filter(s => s.status === 'active')
        } else {
          this.students = await Student.fetch(params)
        }
      }
      this.loading = false
    },
    onChange(data) {
      this.$emit('update:syncedValue', data)
      this.$emit('change', data)
      this.$emit('input', data)
    },
    debounce: debounce(async (search, context) => {
      if (!search || context.student) {
        await context.fetchStudents()
        return
      }

      // this.loading = true
      let params = {
        status: 'active'
      }
      if (context.filter && context.filter.currentClass) {
        params.currentClass = context.filter.currentClass
      } else if (context.ownClassIds) {
        params['currentClass_in'] = context.ownClassIds
      }

      const data = await api.Student.search({
        ...params,
        tags_contains: textHelpers.removeSpaces(utils.clearUnicode(search)),
        _limit: 5,
        _sort: 'nameToNumber:ASC'
      })
      // this.loading = false
      context.students = data
    }, 150)
  },

  computed: {
    ...mapGetters('auth', ['ownClassIds']),
    studentList() {
      const students = orderBy(this.students, ['nameToNumber'], ['asc'])
      return [...students, this.defaultStudent]
        .filter(u => !!u && !!u.code)
        .map(s => ({ ...s, display: `${s.name} [${s.code}]` }))
    }
  }
}
</script>
